import usersApi from '@/pages/Users/users.api'
import { IUser } from '@/pages/Users/users.types'
import useHttpLoader from '@/shared/hooks/useHttpLoader'
import usePersistentState from '@/shared/hooks/usePersistentState'
import { useEffect } from 'react'

const useResponsibleUsers = (responsibleUserIds: IUser['id'][]) => {
  const [responsibleUsers, setResponsibleUsers] = usePersistentState<IUser[]>([], 'responsibleUsers', 'inMemory')
  const { wait, loading } = useHttpLoader()

  useEffect(() => {
    if (responsibleUserIds.length === 0 || !responsibleUserIds) {
      setResponsibleUsers([])
      return
    }

    wait(usersApi.list({ user_id__in: responsibleUserIds.join(',') }), (resp) => {
      if (resp.status === 'success') {
        setResponsibleUsers(resp.body.items)
      }
    })
  }, [responsibleUserIds])

  return {
    responsibleUsers,
    loading,
  }
}

export default useResponsibleUsers
